var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurSerives5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9904 33.2013H47.7957V30.8595H38.9904V33.2013ZM27.0606 39.1368L30.0573 33.2183H27.0606L33.2933 26.031L30.9856 31.4556L33.8128 31.3874L27.0606 39.1368ZM21.4053 33.2013H18.1778V36.4288H15.8359V33.2013H12.5999V30.8595H15.8359V27.632H18.1778V30.8595H21.4053V33.2013ZM8.19727 49.9178H52.1218V21.7476H8.19727V49.9178Z",
    fill: "#E53133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20.0019H53.8171V16.6382H6V20.0019Z",
    fill: "#E53133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0021 12.5547V15.4671H11.8926V12.5547C11.8926 11.1411 13.0337 10 14.4473 10C15.1541 10 15.7843 10.281 16.2527 10.7494C16.7125 11.2092 17.0021 11.8479 17.0021 12.5547Z",
    fill: "#E53133"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.796 12.5547V15.4671H42.6865V12.5547C42.6865 11.1411 43.8276 10 45.2413 10C45.9481 10 46.5868 10.281 47.0466 10.7494C47.515 11.2092 47.796 11.8479 47.796 12.5547Z",
    fill: "#E53133"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurSerives5);
export default __webpack_public_path__ + "static/media/ourSerives5.9846eb9b8a951ddee58cea836f3f41aa.svg";
export { ForwardRef as ReactComponent };